/**
 * Snippet Consent Mode v2 (opt-out Astra): defaults granted até recusa explícita.
 * Referência para tag HTML no GTM web (prioridade 999) e para o loader inline.
 *
 * Sem `wait_for_update`: com os quatro tipos `granted` não há o que aguardar, e a
 * combinação `wait_for_update` + nenhum `gtag('consent','update')` real deixa as tags
 * Google (GA4 e Google Ads) sem disparar (reproduzido em 14/10/2026).
 */
export const GTM_CONSENT_DEFAULT_SCRIPT = `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('consent', 'default', {
  'ad_storage': 'granted',
  'analytics_storage': 'granted',
  'ad_user_data': 'granted',
  'ad_personalization': 'granted'
});
`.trim()

export type GtmConsentState = "granted" | "denied"

export function gtmConsentStateFromTrackingAllowed(trackingAllowed: boolean): GtmConsentState {
  return trackingAllowed ? "granted" : "denied"
}

/**
 * Atualiza o Consent Mode com `gtag('consent','update')` (o GTM só reconhece consentimento
 * em comandos gtag) e mantém o evento `consent_update` no dataLayer.
 */
export function pushGtmConsentUpdate(trackingAllowed: boolean): void {
  if (typeof window === "undefined") return
  const state = gtmConsentStateFromTrackingAllowed(trackingAllowed)
  window.dataLayer = window.dataLayer ?? []
  const gtag = (window as Window & { gtag?: (...args: unknown[]) => void }).gtag
  if (typeof gtag === "function") {
    gtag("consent", "update", {
      analytics_storage: state,
      ad_storage: state,
      ad_user_data: state,
      ad_personalization: state,
    })
  }
  window.dataLayer.push({
    event: "consent_update",
    analytics_storage: state,
    ad_storage: state,
    ad_user_data: state,
    ad_personalization: state,
  })
}
